import React from "react";
import { Outlet, Link } from 'react-router-dom'
import backgroundImage from "../assets/images/Login-bg.svg";
import logo from "../assets/logo.svg";

const LoginLayout = () => {
    return (
        <div className="relative flex items-center justify-center min-h-screen w-full px-6 bg-primary-light overflow-hidden">
            {/* background image */}
            <div
                className="absolute top-0 left-0 w-full h-full bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: `url(${backgroundImage})`,
                }}
            />
            <div>
                <Link to="/">
                    <img
                        src={logo}
                        alt="Logo"
                        className="absolute top-[29px] left-[50px] w-[141.81px] h-auto cursor-pointer"
                    />
                </Link>
            </div>

            {/* Content container */}
            <div className="relative z-10 w-full flex items-center justify-center">
                <Outlet />
            </div>
        </div>
    );
}

export default LoginLayout;